module.exports = "<div [formGroup]=\"formGroup\">\n    <div class=\"content dropdown-container\"></div>\n</div>\n "


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/dropdown-choice-view/dropdown-choice-view.html
// module id = z8Id
// module chunks = 3